//if slotValue === '' it is empty
//so the schele duration for the day should be from 00:00 to 23:59, the whole day
import { IRawSchedule } from '../../models';

export function modifyIfEmpty(slotValue: IRawSchedule & string, index: number): any {
  if (index === 0 && slotValue === '') {
    return {hours: '0', minutes: '0'};
  } if (index === 1 && slotValue === '') {
    return { hours: '23', minutes: '59'}
  }

  return slotValue;
}
